import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { Session } from "./utils/session";

export default function GoogleAuth() {
  const navigate = useNavigate();

 useEffect(() => {

    console.log("GoogleAuth useEffect");
    const googleToken = sessionStorage.getItem("google_access_token");

    if (googleToken) {
        const role = Session.getRole();

        if (role === "Super Admin" || role === "Admin") {
            navigate("/dashboard", { replace: true });
        } else {
            navigate("/dailytask", { replace: true });
        }
        return;
    }

    // Already opened once
    if (window.googlePopupOpened) {
        return;
    }

    window.googlePopupOpened = true;

  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;

  script.onload = () => {
    signInWithGoogle();
  };

  document.body.appendChild(script);

}, [navigate]);

const signInWithGoogle = () => {
     console.log("signInWithGoogle");
    const codeClient =
        window.google.accounts.oauth2.initCodeClient({
          
            client_id:"251591668926-kon8qbuu2g381smt60tc7t9g4auu8amn.apps.googleusercontent.com",
            scope:"https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets openid email profile",
            ux_mode: "popup",

            callback: async (response) => {
                try {

                    if (!response?.code) {
                        alert("Google Authorization Code Not Found");
                        return;
                    }

                    const saveResponse = await fetch(
                        `${API_BASE_URL}/api/Auth/GoogleAuthCode`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${Session.getToken()}`
                            },
                            body: JSON.stringify({
                                userId: Session.getUserId(),
                                code: response.code
                            })
                        }
                    );

                    const responseText =
                        await saveResponse.text();

                    if (!saveResponse.ok) {
                        alert(  `GoogleAuthCode Failed\n\n${responseText}`);
                        return;
                    }
                const result = JSON.parse(responseText);
                sessionStorage.setItem( "google_access_token",result.googleAccessToken);
                window.googlePopupOpened = false;
                const role = Session.getRole();

                if (role === "Super Admin" || role === "Admin") {
                navigate("/dashboard", { replace: true });
                } else {
                navigate("/dailytask", { replace: true });
                }   }
             catch (err) {
                 console.error(err);
                  alert("Google Authentication Failed");
                }
            }
         });

         codeClient.requestCode();
     };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="text-center">
        <h3>Google Authentication</h3>
        <p>Please wait...</p>
      </div>
    </div>
  );
}